<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh2"><a id="page_2"><b>GLOSSARY and ABBREVIATIONS</b></a></p><a id="page_2">
<p class="fmh3"><b>Glossary</b></p>
<table border="0" cellpadding="1" cellspacing="0" width="100%">
<colgroup>
<col width="20%"/>
<col width="80%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"><i>Baraza</i></td>
<td valign="top">a council of chiefs or elders</td>
</tr>
<tr>
<td valign="top"><i>kipande</i></td>
<td valign="top">identification documents which all natives of the colony were required to carry</td>
</tr>
<tr>
<td valign="top"><i>Kuke/Kukes</i></td>
<td valign="top">refers to Kikuyu</td>
</tr>
<tr>
<td valign="top">Micks/Mickeys</td>
<td valign="top">vernacular name applied by government forces to Mau Mau; Micky was short for Micky Mouse, implying the double initial M.</td>
</tr>
<tr>
<td valign="top"><i>Muhimu</i></td>
<td valign="top">the Central Committee of Mau Mau responsible for organisation, logistics and political representation</td>
</tr>
<tr>
<td valign="top"><i>Ngai</i></td>
<td valign="top">the supreme God in the religions of the Kamba, Kikuyu and Maasai nationalities of Kenya; according to the Kikuyu beliefs, he lives on the holy mountain <i>Kirinyaga, or</i> Mount Kenya.</td>
</tr>
<tr>
<td valign="top"><i>Pax Britannia</i></td>
<td valign="top">those areas of the globe that came under British imperial protection; literally the <i>peace of Britain</i>.</td>
</tr>
<tr>
<td valign="top"><i>posta</i></td>
<td valign="top">a location used as a ‘post box’ for internal Mau Mau communications and dispatches</td>
</tr>
<tr>
<td valign="top"><i>simi</i></td>
<td valign="top">a panga, a machete-like utility knife in wide use throughout Africa</td>
</tr>
</tbody>
</table>
<p class="noindent">White Highlands the Central Highlands, settled by whites</p>
<p class="fmh3"><b>Abbreviations</b></p>
<table border="0" cellpadding="1" cellspacing="0" width="100%">
<colgroup>
<col width="20%"/>
<col width="80%"/>
</colgroup>
<tbody>
<tr>
<td valign="top">EAA</td>
<td valign="top">East African Association</td>
</tr>
<tr>
<td valign="top">FIA</td>
<td valign="top">Field Intelligence Officer</td>
</tr>
<tr>
<td valign="top">GHQ</td>
<td valign="top">General Head Quarters</td>
</tr>
<tr>
<td valign="top">GOC</td>
<td valign="top">General Officer Commanding</td>
</tr>
<tr>
<td valign="top">HQ</td>
<td valign="top">Head Quarters</td>
</tr>
<tr>
<td valign="top">IBEAC</td>
<td valign="top">Imperial British East African Company</td>
</tr>
<tr>
<td valign="top">KAR</td>
<td valign="top">King’s African Rifles</td>
</tr>
<tr>
<td valign="top">KA</td>
<td valign="top">Kikuyu Association</td>
</tr>
<tr>
<td valign="top">KCA</td>
<td valign="top">Kikuyu Central Association</td>
</tr>
<tr>
<td valign="top">KAU</td>
<td valign="top">Kenya African Union</td>
</tr>
<tr>
<td valign="top">PSYOPS</td>
<td valign="top">psychological operations</td>
</tr>
<tr>
<td valign="top">RAF</td>
<td valign="top">Royal Air Force</td>
</tr>
<tr>
<td valign="top">SITREP</td>
<td valign="top">situation report</td>
</tr>
<tr>
<td valign="top">SMLE</td>
<td valign="top">Short Magazine Lee Enfield</td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// glossary.vue?4a664996